SingleProduct.directive( 'addToCart', [ 'VariationsSrv', 'CartSrv', function( VariationsSrv, CartSrv ) {
	return {
		restrict: 'A',
		link: function( scope, element ) {
			element.on('click', function (e) {
				e.preventDefault();
				GA.send('Product Pages', 'Add to Cart');

				$('.error-massage').text('').fadeOut();
				var validation_results = VariationsSrv.validateVariations();

				if( validation_results.result ) {
					element.addClass('loading');
					VariationsSrv.addToCart().then(
						function( status ){
							CartSrv.getRelatedProducts().then(
								function ( relatedProducts ) {
									element.removeClass('loading')
									if( relatedProducts )
										Overlay.setContent('itemAddedMoreItems', relatedProducts );
									else
										Overlay.setContent('itemAdded', '');

									scope.variations.resetFields()
									scope.variations.resetData()
								}
							)
						}
					)
				}
				else{
					$('.error-massage').text(validation_results.message).fadeIn();
				}
			})
		}
	}
}] )